import React from "react";
import { useRef } from "react";
import { LayoutMain } from "@unisearch/theme/layout";
import {
  VOfficeHero,
  VOfficeIntroducing,
  VOfficeForm,
} from "@modules/study/virtualoffice";

const VirtualOffice = () => {
  return (
    <LayoutMain
      footer_with_evaluation
      title="Virtual Office"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/virtual-office`}
    >
      <VOfficeHero />
      <VOfficeIntroducing />
      <div id="vPopup">
        <VOfficeForm />
      </div>
    </LayoutMain>
  );
};

export default VirtualOffice;
